// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__16oVY","flexColumn":"Flex_flexColumn__zfMtW","sidebar":"Flex_sidebar__3W1mo","mainContent":"Flex_mainContent__11H-H"};